
import {put, call } from 'redux-saga/effects';
// import fetch from 'isomorphic-fetch';

import { productInfo } from '../actions/index.js';
import { countService } from '../services/index.js';

export function* testSaga() {
    const response = yield call(countService);
    const data = yield response.data;
    yield put(productInfo(data));
}